export enum guestActionTypes {
	GET_ALL_GUESTS = 'GET_ALL_GUESTS',
	GET_ALL_GUESTS_SUCCESS = 'GET_ALL_GUESTS_SUCCESS',

	GET_ALL_GUESTS_LIST = 'GET_ALL_GUESTS_LIST',
	GET_ALL_GUESTS_LIST_SUCCSSES = 'GET_ALL_GUESTS_LIST_SUCCSSES'
}
